import { Subject } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MapService } from '~app/shared/map/map.service';
import { FluentLayerHelper } from '../fluent/fluent-layer-helper';
import { FluentDatasource } from '../fluent/fluent-interfaces';

@Component({
  selector: 'qm-joensuu-base',
  templateUrl: './joensuu-base.component.html'
  //styleUrls: ['./name.component.scss']
})
export class JoensuuBaseComponent implements OnInit, OnDestroy {
  private fluentLayers: FluentLayerHelper;
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private mapService: MapService,
    private fluent: FluentDatasource) {
  }

  async ngOnInit() {
    this.fluentLayers = new FluentLayerHelper(this.mapService, this.fluent, this.ngUnsubscribe);
    await this.fluentLayers.init();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
